// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__164UX","left":"StickyBox_left__1cLSK","right":"StickyBox_right__22OxQ"};